import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { settings } from '../lib/api';
import { queryKeys } from './queryKeys';

export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings,
    queryFn: () => settings.get(),
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { name?: string; photo_key?: string }) => settings.update(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.settings }),
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }) =>
      settings.changePassword(currentPassword, newPassword),
  });
}
